import { Injectable, inject } from '@angular/core';

import { SecurityRouterStoreSelectors, UserGroupAclStoreActions, UserGroupAclStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { first, map, mergeMap, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class GroupPermissionResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(SecurityRouterStoreSelectors.selectCurrentGroupId).pipe(
      mergeMap((groupId) =>
        groupId
          ? this.store.select(UserGroupAclStoreSelectors.selectUserGroupAclByResource(groupId)).pipe(
              tap((y) => {
                if (y === undefined) {
                  this.store.dispatch(
                    UserGroupAclStoreActions.SettingPermissionsResolverActions.userGroupAclRequested({
                      resourceId: groupId,
                    })
                  );
                }
              })
            )
          : of(undefined)
      ),
      map(() => true),
      first()
    );
  }
}
